import { API } from 'utils/api/api'
import { formatRequestString } from 'utils/helpers/api/queryString'

interface GetChatsByUserParams {
  userId: string
}

export const getChatsByUser = ({ userId }: GetChatsByUserParams) => {
  const entityUrl = `/api/users/${userId}/chat`
  return API.get(formatRequestString({ entityUrl }))
}
